import React from 'react';

/**
 * @param {object} props
 * @return {*}
 * @constructor
 */
export default ({className, id, placeholder, value, onChange, disabled, rows, onKeyPress, onBlur, readOnly}) => (
    <textarea
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={onChange}
        rows={rows}
        onKeyPress={onKeyPress}
        onBlur={onBlur}
        className={`border p-2 border-gray-300 rounded-md block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 ${className}`}
        readOnly={readOnly}
    />
);
